import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1em;
`;

export const Close = styled(CloseIcon)`
  cursor: pointer;
`;

export const Content = styled(Box)`
  flex-grow: 1;
`;

export const CartTogglerWrapper = styled.div`
  position: relative;
`;

export const CustomBadge = styled(Badge)`
  .MuiBadge-badge {
    background-color: white;
    color: black;
  }
`;
